import * as React from 'react';
import Logo from '@/assets/img/logo-v2.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';

import { useAuth } from '@/lib/auth';

import { ReactComponent as StoreIcon } from '@/assets/img/v2/store-icon.svg';
import UserIcon from '@/assets/img/v2/default-user-icon.png';
import { ReactComponent as ProfileIcon } from '@/assets/img/v2/profile-icon.svg';
import { ReactComponent as PawIcon } from '@/assets/img/v2/paw-icon.svg';
import { ReactComponent as PaymentCardIcon } from '@/assets/img/v2/payment-card-icon.svg';
import { ReactComponent as AppointmentIcon } from '@/assets/img/v2/appointment-icon.svg';
import { ReactComponent as BookingIcon } from '@/assets/img/v2/booking-icon.svg';
import { ReactComponent as LogoutIcon } from '@/assets/img/v2/logout-icon.svg';
import { ReactComponent as NotificationIcon } from '@/assets/img/v2/notification-icon-header.svg';
import DownArrow from '@/assets/img/down-arrow.svg';
import { useTranslation } from 'react-i18next';
import './Header.scss';
import { WEBSITE_URL } from '@/config';
import { LanguageDropDown } from '@/features/Language/LanguageDropDown';

export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const onMenuClick = (page: string) => {
    navigate(page);
  };
  const inviteFriends = () => {};
  const onLogoutClicked = async () => {
    await logout();
    //navigate(`/shops`);
    localStorage.removeItem('UsersEmail');
  };
  const onHeaderLogoClicked = () => {
    const isScheduleDemo = location.pathname.indexOf('schedule-demo') >= 0 ? true : false;
    if (isScheduleDemo) {
      window.open(WEBSITE_URL, '_self');
    } else {
      navigate(`/shops`);
    }
  };
  const { t, i18n } = useTranslation();
  const showExploreButton =
    location.pathname.length > 1
      ? location.pathname.indexOf('shops') < 0
        ? true
        : false
      : location.pathname == '/'
      ? false
      : true;
  return (
    <header>
      <Navbar className='main-navbar' expand="lg">
        <Navbar.Brand href="#home">
          <div className="brand-details">
            <img className="logo" src={Logo} alt="Logo" onClick={onHeaderLogoClicked} />
          </div>
        </Navbar.Brand>
        {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
        <Navbar id="responsive-navbar-nav">
          <Nav className="me-auto"></Nav>
        {/* <LanguageDropDown/> */}
          {user && user.email && (
            <Nav>
              {showExploreButton && (
                <button
                  className="petsked-button button-dark icon explore"
                  onClick={() => onMenuClick('shops')}
                >
                  <StoreIcon />
                  {t('Explore Stores')}
                </button>
              )}
              <span className="vertical-seperator"></span>
              {/* <Nav.Link className="notification-link">
                <NotificationIcon />
                <span className="count">3</span>
              </Nav.Link> */}
              <Nav.Link>
                <Dropdown className="white header-menu">
                  <Dropdown.Toggle className="petsked-dropdown-toggle">
                    <img
                      className="user-logo-icon"
                      src={user?.imageUrl ? user.imageUrl : UserIcon}
                    />
                    <img src={DownArrow} className="down-arrow" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => onMenuClick('my-profile')}>
                      <ProfileIcon /> <span>{t('Profile')}</span>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => onMenuClick('my-pet-profiles')}>
                      <PawIcon /> <span>{t('My Pet')}</span>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => onMenuClick('my-payment-methods')}>
                      <PaymentCardIcon /> <span>{t('Payment Methods')}</span>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => onMenuClick('my-appointments')}>
                      <AppointmentIcon /> <span>{t('Appointments')}</span>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => onMenuClick('my-bookings')}>
                      <BookingIcon /> <span>Boarding Bookings</span>
                    </Dropdown.Item>
                    {/* <Dropdown.Item onClick={inviteFriends}>
                      <ShareIcon /> <span>Invite Friends</span>
                    </Dropdown.Item> */}
                    <hr />
                    <Dropdown.Item className="logout" onClick={onLogoutClicked}>
                      <LogoutIcon /> <span>{t('Logout')}</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Nav.Link>
            </Nav>
          )}
        </Navbar>
      </Navbar>
    </header>
  );
};
